import { FaRegBookmark, FaBookmark } from "react-icons/fa";
import "./NewsList.css";
import firestore from "../../handlers/firestore";
import { useAuthContext } from "../context/AuthContext";
import { motion } from "framer-motion";
import { useFavourite } from "../context/FavouriteContext";
import { toast } from "react-toastify";
import FallbackImg from "../../assets/fallback.jpg";

function NewsList(props) {
  const { currentUser} = useAuthContext();
  const { writeDoc, deleteDoc } = firestore;
  const { favourites, setFavourites } = useFavourite();
  const toggleFavorite = async (news) => {
  const favItem = favourites.find((item) => item.url === news.url);

  if (!favItem) {
    const newNews = { ...news, email: currentUser.email };

    try {
      await writeDoc(newNews);
      setFavourites((prev) => [...prev, newNews]);
      toast.success("Added to Favorites!");
    } catch {
      toast.error("Failed to add favorite!");
    }
  } else {
    try {
      await deleteDoc(favItem.id);
      setFavourites((prev) =>
        prev.filter((item) => item.url !== news.url)
      );
      toast.info("Removed from Favorites");
    } catch {
      toast.error("Failed to remove favorite!");
    }
  }
};

  if (!props.articles || props.articles.length === 0) {
    return <h2>No news available</h2>;
  }

  return props.articles.map((news, index) => {
    const isFavorite = favourites?.some((item) => item.url === news.url);

    const image = news.urlToImage || news.image || FallbackImg;
    const author = news.author || "Unknown Author";
    const description = news.description || "No description available";
    const date = news.publishedAt
      ? news.publishedAt.split("T")[0]
      : "Unknown date";
    const source = news.source?.name || "Unknown source";

    return (
      <motion.div
        key={news.id || index}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="card_container"
      >
       <button
  className="bookmark_button"
  onClick={() => {
    if (!currentUser) {
      toast.info("Please login first");
      return;
    }
    toggleFavorite(news);
  }}
>
  {isFavorite ? <FaBookmark /> : <FaRegBookmark />}
</button>
        <a
          href={news.url}
          target="_blank"
          rel="noopener noreferrer"
          className="card_img_container"
        >
          <img
            src={image}
            className="card_image"
            alt={news.title}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = FallbackImg;
            }}
          />
        </a>

        <div className="card_title_contianer">
          <a
            href={news.url}
            target="_blank"
            rel="noopener noreferrer"
            className="card_title_anchor"
          >
            <h2 className="card_title">{news.title}</h2>
          </a>

          <p className="card_desc">{description}</p>
        </div>

        <div className="footer_container">
          <div className="author_info_container">
            <span className="author_name">{author}</span>
            <span className="author_date">{date}</span>
          </div>

          <div className="news_source">
            <span>{source}</span>
          </div>
        </div>
      </motion.div>
    );
  });
}

export default NewsList;
